export default __webpack_public_path__ + "static/media/polar-strings.653248fd.png";